module.exports = __webpack_public_path__ + "static/media/python.3348be4d.png";